module.exports = __webpack_public_path__ + "static/scale-model-of-riveredge-park-in-aurora-illinois-508ce7abc0cc26552d1422ae416aadc8.png";